import { createApp } from "vue";
import Antd from "ant-design-vue";
import axios from "axios";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import { DO_LOGOUT } from "@/store/modules/autenticacao/types";
import { install } from "vue3-recaptcha-v2";
import VueTheMask from "vue-the-mask";

import "@/assets/styles/theme.less";

async function carregarConfiguracoes(app) {
	const [login, novidade] = await Promise.all([
		axios.get("/config/portalData.json"),
		axios.get('/config/novidadeData.json')
	]);

	app.config.globalProperties.$config = {
		login: login.data,
		novidade: novidade.data
	};
}

function removerLoading() {
	const loading = document.getElementById("app-loading");

	if (!loading) {
		return;
	}

	loading.classList.add("hide");

	setTimeout(() => {
		loading.remove();
	}, 400);
}

function exibirErroLoading() {
	const loading = document.getElementById("app-loading");

	if (!loading) {
		return;
	}

	loading.innerHTML = `
		<div class="app-loading-content">

			<div class="app-loading-logo">
				<img          
					src="/kurierLogo2.png"
					alt="Kurier Analytics"
					style="width: 350px;"
				/>
			</div>

			<div class="app-loading-title">
				Não foi possível iniciar o sistema
			</div>

			<div class="app-loading-description">
				Aguarde alguns minutos e tente novamente.<br/>
				Ou entre em contato com a Kurier.
			</div>
		</div>
	`;
}

async function iniciarAplicacao() {
	try {
		const app = createApp(App);

		app.config.globalProperties.$logout = () => {
			store.dispatch(DO_LOGOUT);

			router.push({ name: "login" });
		};
		
		await carregarConfiguracoes(app);

		app
			.use(install, {
				sitekey: process.env.VUE_APP_KEY_RECAPTCHA_V2,
				cnDomains: false,
			})
			.use(Antd)
			.use(store)
			.use(router)
			.use(VueTheMask);

		app.mount("#app");

		removerLoading();
	} catch (error) {
		console.error("Erro ao iniciar aplicação:", error);
		exibirErroLoading();
	}
}

iniciarAplicacao();